import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setChildInn } from 'modules/App/redux/app/actions';
import { remotePaths } from 'router/routes';

const FamilyAccessTitle = ({ value, original: { active, relationAvailable, inn } }) => {
  const dispatch = useDispatch();
  return active && relationAvailable ? (
    <a
      href={remotePaths.taxes}
      onClick={() => {
        dispatch(setChildInn(inn));
      }}
    >
      {value}
    </a>
  ) : (
    value
  );
};

FamilyAccessTitle.propTypes = {
  value: PropTypes.string.isRequired,
  original: PropTypes.shape({
    active: PropTypes.bool,
    relationAvailable: PropTypes.bool,
    inn: PropTypes.string.isRequired,
  }),
};

export default FamilyAccessTitle;
